import { render, staticRenderFns } from "./otherApplyDetail.vue?vue&type=template&id=8ff3f902&scoped=true&"
import script from "./otherApplyDetail.vue?vue&type=script&lang=js&"
export * from "./otherApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./otherApplyDetail.vue?vue&type=style&index=0&id=8ff3f902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff3f902",
  null
  
)

export default component.exports